export enum PatientFormError {
  UniquePhoneNumber = "mobilePhoneNumber: Phone number must be unique",
}
